module.exports = __webpack_public_path__ + "static/media/Messages.c5e390a2.svg";